import linksJSON from '../data/links.json' with { type: 'json' };

const ALUMINUM_GENERIC_LINK = 'https://www.hobartbrothers.com/products/aluminum-mig-tig/';

/**
 * Resolves a product link from the centralized links database.
 * @param {string} productName - The product name to look up
 * @returns {string|null} The product URL or null if not found
 */
export function resolveProductLink(productName) {
  if (!productName) return null;
  return linksJSON[productName] || null;
}

/**
 * Enriches an object with a link property based on its product_name or hobart_product_name.
 * @param {Object} obj - Object containing product_name or hobart_product_name
 * @param {Object} options - Options for enrichment
 * @param {boolean} options.useAluminumFallback - If true, uses generic aluminum link as fallback
 * @returns {Object} The same object with link property added or updated
 */
export function enrichWithLink(obj, options = {}) {
  if (!obj) return obj;

  const productName = obj.product_name || obj.hobart_product_name;
  if (productName) {
    const link = resolveProductLink(productName);
    if (link) {
      obj.link = link;
    }
  } else if (options.useAluminumFallback && obj.filler) {
    obj.link = ALUMINUM_GENERIC_LINK;
  }

  return obj;
}

/**
 * Recursively enriches all objects in a data structure with links.
 * @param {any} data - Data structure to enrich
 * @param {Object} options - Options for enrichment
 * @param {boolean} options.useAluminumFallback - If true, uses generic aluminum link as fallback
 * @returns {any} The enriched data structure
 */
export function enrichDataWithLinks(data, options = {}) {
  if (!data) return data;

  if (Array.isArray(data)) {
    return data.map((item) => enrichDataWithLinks(item, options));
  }

  if (typeof data === 'object') {
    const productName = data.product_name || data.hobart_product_name;
    if (productName || (options.useAluminumFallback && data.filler)) {
      enrichWithLink(data, options);
    }

    for (const key in data) {
      if (typeof data[key] === 'object') {
        data[key] = enrichDataWithLinks(data[key], options);
      }
    }
  }

  return data;
}
